(function () {
  'use strict';

  var STORAGE_KEY = 'ce_lead_pilot_attribution_v2';
  var RETENTION_MS = 90 * 24 * 60 * 60 * 1000;
  var FIELDS = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
  ];

  var hasPersisted = false;

  try {
    var params = new URLSearchParams(window.location.search);
    var touch = {};
    var hasCampaignParameter = false;
    FIELDS.forEach(function (name) {
      var value = params.get(name);
      if (!value) return;
      touch[name] = value.slice(0, 512);
      hasCampaignParameter = true;
    });

    if (!hasCampaignParameter) return;

    var now = new Date();
    touch.captured_at = now.toISOString();
    touch.landing_url = withoutHash(window.location.href).slice(0, 2048);
    touch.referrer = (document.referrer || '').slice(0, 2048) || null;
    persistWhenAllowed(touch, now);
  } catch (error) {
    // A captura é auxiliar e nunca pode interferir na navegação da loja.
  }

  function persistWhenAllowed(touch, now) {
    var persist = function () {
      if (hasPersisted || !trackingAllowed()) return;
      hasPersisted = true;
      persistTouch(touch, now);
    };

    persist();
    document.addEventListener('trackingConsentAccepted', persist, { once: true });
    document.addEventListener('visitorConsentCollected', persist, { once: true });

    var shopify = window.Shopify;
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error) persist();
        }
      );
    }
  }

  function trackingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return false;
    try {
      if (typeof privacy.analyticsProcessingAllowed === 'function') {
        return !!(
          privacy.analyticsProcessingAllowed() ||
          (typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed())
        );
      }
      return typeof privacy.userCanBeTracked === 'function' && !!privacy.userCanBeTracked();
    } catch (error) {
      return false;
    }
  }

  function persistTouch(touch, now) {
    try {
      var stored = parseJson(localStorage.getItem(STORAGE_KEY)) || {};
      var expiresAt = Date.parse(stored.expires_at || '');
      if (!Number.isFinite(expiresAt) || expiresAt <= now.getTime()) stored = {};

      if (!stored.first_touch) stored.first_touch = touch;
      stored.last_touch = touch;
      stored.updated_at = touch.captured_at;
      stored.expires_at = new Date(now.getTime() + RETENTION_MS).toISOString();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (error) {
      // O armazenamento local também é opcional.
    }
  }

  function withoutHash(value) {
    return String(value || '').split('#')[0];
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }
})();
